<ng-container *ngFor="let item of metaNavItems">
  <ng-container *ngIf="item.menuType !== metaMenuType.CART; else cartTpl">
    <button
      (click)="onMenuSelect(item)"
      shrdUicButton
      [variant]="btnVariant"
      [attr.title]="btnTitle"
      [ngClass]="className"
      [shrdUtcTrackEvent]="{ category: 'SiteOperations', action: 'MainNavigation', label: item.trackingName }"
    >
      <ng-container *ngIf="withArrowIcon; else withoutArrow">
        <span>{{ item.title }}</span>
        <shrd-uic-svg-icon class="text-center btn-icon" icon="arrow-right"></shrd-uic-svg-icon>
      </ng-container>
      <ng-template #withoutArrow>
        <span *ngIf="item?.headerLabel">{{ item.title }}&#x200E;</span>
        <span *ngIf="!item?.headerLabel">{{ item.title }}</span>
      </ng-template>
    </button>
  </ng-container>
  <ng-template #cartTpl>
    <a
      shrdUicButton
      [variant]="btnVariant"
      [href]="cartUrl"
      class="my-0 w-100"
      [shrdUtcTrackEvent]="{ category: 'SiteOperations', action: 'MainNavigation', label: item.trackingName }"
    >
      <span>{{ item.title }}</span>
    </a>
  </ng-template>
</ng-container>
